import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import store from './store'

Vue.use(Router)
Vue.use(VueResource)

var router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login' || to.name === 'logout') {
    next()
  } else if (store.state.auth.user === null) {
    next({ name: 'login'})
  } else if (store.state.auth.user.isExpired === true) {
    next({ name: 'logout' })
  } else {
    next()
  }
})

export default router
